"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoIframe = void 0;

var _fill = require("../../layout/fill");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * `Wrapper` styled component.
 */
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "video-iframe__Wrapper",
  componentId: "r5fn21-0"
})(["height:100%;position:relative;"]);
/**
 * `Iframe` styled component.
 */


var Iframe = (0, _styledComponents.default)(_fill.Fill).withConfig({
  displayName: "video-iframe__Iframe",
  componentId: "r5fn21-1"
})(["border:0;height:100%;width:100%;"]);
/**
 * Export `VideoIframe` component.
 */

var VideoIframe = function VideoIframe(props) {
  var url = props.url,
      rest = _objectWithoutProperties(props, ["url"]);

  return _react.default.createElement(Wrapper, null, _react.default.createElement(Iframe, _extends({
    as: 'iframe'
  }, rest, {
    src: url
  })));
};

exports.VideoIframe = VideoIframe;